module.exports = __webpack_public_path__ + "img/Compact-FR_Overview-GB_1.f9154983.jpg";